import React from "react";
import Box from "@mui/material/Box";
import { GridToolbarColumnsButton } from "@mui/x-data-grid";

// Columns only: the report's own filters, above the grid, decide the rows.
export const CustomToolbar = () => {
  return (
    <Box
      sx={{
        p: 1,
        display: "flex",
        justifyContent: "flex-start",
      }}
    >
      <GridToolbarColumnsButton />
    </Box>
  );
};
